import service from '@/services/types/exoneracion'

export const namespaced = true

export const state = () => ({
  list: [],
  cabys: []
})

export const mutations = {
  LIST: (state, objs) => (state.list = objs),
  CABYS: (state, objs) => (state.cabys = objs)
}

export const actions = {
  list: ({ commit }, value) =>
    service.list(value).then(result => {
      commit('LIST', result)

      return result
    }),

  exonet: ({ commit }, autorizacion) => {
    return service.exonet(autorizacion).then(result => {
      if (result.cabys) commit('CABYS', result.cabys)

      return result
    })
  },

  cleanCabys: ({ commit }) => commit('CABYS', [])
}

export const getters = {
  getCabys: state => state.cabys
}
